<template>
  <div class="main-content">
    <h2>我的报告
      <span class="btn btn-primary right" @click="download()" v-if="report.abilities.length !== 0 && need_refresh !== 1">下载报告</span>
      <span class="btn btn-primary right" @click="refresh()" v-if="need_refresh === 1">重新生成</span>
    </h2>
    <div id="report-area" class="row">
      <div class="col-xs-12">
        <div class="b-b m-b-sm"></div>
        <loading v-if="loading === 1"></loading>
        <div v-show="loading === 0">
          <div class="tips" v-show="report.abilities.length === 0">
            您暂未获得测评数据，请前往
            <router-link to="/evaluate">测评中心</router-link>进行素质测评，生成测评数据。
          </div>
          <div v-show="report.abilities.length !== 0">
            <div class="row">
              <div class="col-xs-12 m-b-sm">
                <div style="height:20px;background:#42b983;"></div>
              </div>
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-6">
                    <img src="/assets/images/psych2_4_2.jpg" alt="" class="psych-logo left" height="60">
                  </div>
                  <div class="col-xs-6">
                    <img src="/assets/images/lechenggu-logo.png" alt="" class="lechenggu-logo left right" height="60">
                  </div>
                </div>
              </div>
              <h1 class="p-t-b-md n-m-b text-center">个人测评报告</h1>
            </div>
            <div class="row user-info p-t-b-sm snapshort">
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-6">
                    <div class="line">
                      <span class="label">姓名:</span>
                      <span class="info">{{user.realname}}</span>
                    </div>
                    <div class="line">
                      <span class="label">邮箱:</span>
                      <span class="info">{{user.email}}</span>
                    </div>
                    <div class="line" v-if="user.phone">
                      <span class="label">手机:</span>
                      <span class="info">{{user.phone}}</span>
                    </div>
                  </div>
                  <div class="col-xs-6">
                    <img :src="user.avatar" alt="" width="100" class="m-r-sm right">
                  </div>
                </div>
                <div class="b-b m-b-sm"></div>
              </div>
              <div class="col-xs-12" v-if="report.abilities && report.abilities.length >= 3">
                <radar style="height:300px;" :title="radar_data.title" :legend="radar_data.legend" :series="radar_data.series" :indicator="radar_data.indicator"></radar>
                <div class="b-b"></div>
              </div>
              <div class="col-xs-12" v-if="report.abilities && report.abilities.length >= 3">
                <div id="bar-area" style="width:100%;height:300px;"></div>
                <div class="b-b m-b-sm"></div>
              </div>
            </div>
            <div class="row" v-show="detail_data === 0">
              <div class="col-xs-12 m-t-b-sm ability snapshort" v-for="(ability,ind) in report.abilities" :key="ability._id" :class="{'open': ability.is_open === 1}">
                <div class="btn btn-md n-b-r col-xs-12 n-f btn-success">
                  <div class="row">
                    <div class="col-xs-12 col-sm-3">
                      <span>能力名称：</span>
                      <span class="bold">{{ability.ability.name}}</span>
                    </div>
                  </div>
                </div>
                <div class="detail col-xs-12">
                  <div class="row p-b-sm">
                    <div class="col-xs-12 col-sm-4">
                      <div class="row">
                        <div class=" p-t-b-sm" v-if="ability.ability.desc">
                          <div class="col-xs-12" style="padding-left:5px;">
                            <!-- <div class="label">说明：</div> -->
                            <div class="desc" v-html="ability.ability.desc"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <div class="row">
                        <Scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :type="2" :target="ability.ability._id" :name="ability.ability.name" :score="ability.score" :rate="ability.rate"></Scatter>
                        <div class="col-xs-12 m-t-xs text-center p-b-xs" style="font-size:14px;">
                          <span class="score">{{ability.score.toFixed(2)}}分</span>,领先
                          <span class="score">{{(ability.rate*100).toFixed(2)}}%</span>的用户</div>
                        <!-- <svg-circle :length="140" :width="10" :rate="ability.rate" style="margin:0 auto;"></svg-circle>
                                                <div class="col-xs-12 m-t-xs text-center"><span class="score">{{ability.score.toFixed(2)}}</span></div>
                                                <div class="col-xs-12 m-t-b-xs text-center name">能力排行</div> -->
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <div class="row">
                        <div class="col-xs-12 p-t-b-sm" v-if="ability.grade_desc">
                          <div class="label">解析：</div>
                          <div class="desc" v-html="ability.grade_desc"></div>
                        </div>
                        <div class="col-xs-12 p-t-b-sm" v-if="ability.grade_suggestion">
                          <div class="label">建议：</div>
                          <div class="desc" v-html="ability.grade_suggestion"></div>
                        </div>
                        <div class="col-xs-12 p-t-b-sm" v-if="ability.grade_improvement">
                          <div class="label">改善：</div>
                          <div class="desc" v-html="ability.grade_improvement"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="b-b"></div>
                  <div class="row p-b-sm" v-if="ability.indicators.length >=3">
                    <div class="row">
                      <radar class="col-xs-12" style="height:300px;" :title="ability.radar_data.title" :legend="ability.radar_data.legend" :series="ability.radar_data.series" :indicator="ability.radar_data.indicator"></radar>
                    </div>
                    <div class="b-b clearfix"></div>
                  </div>
                  <div class="row p-b-sm">
                    <div class="indicator col-xs-12 m-b-sm" :class="{'col-sm-4':ability.indicators.length >=3 || ability.indicators.length ===1,'col-sm-6':ability.indicators.length ===2}" v-for="indicator in ability.indicators" :key="indicator._id">
                      <!-- <svg-circle :length="120" :width="10" :rate="indicator.rate" style="margin:0 auto;"></svg-circle> -->
                      <div class="row">
                        <!-- <div class="col-xs-12 m-t-xs text-center score">{{indicator.score.toFixed(2)}}</div>
                                                        <div class="col-xs-12 m-t-b-xs text-center name">{{indicator.indicator.name}}</div> -->
                        <Scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :type="1" :target="indicator.indicator._id" :name="indicator.indicator.name" :score="indicator.score" :rate="indicator.rate"></Scatter>
                        <div class="col-xs-12 m-t-xs text-center p-b-xs" style="font-size:14px;">
                          <span class="score">{{indicator.score.toFixed(2)}}分</span>,领先
                          <span class="score">{{(indicator.rate*100).toFixed(2)}}%</span>的用户</div>
                        <div class=" p-t-b-sm" v-if="indicator.grade_desc">
                          <div class="col-xs-12">
                            <div class="row p-l-r-xs">
                              <div class="label">指标解析：</div>
                              <div class="desc" v-html="indicator.grade_desc"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="text-center">
                <span>本报告由</span>
                <a href="http://www.psych.cas.cn" title="中国科学院心理研究所·心理健康应用中心" alt="中国科学院心理研究所·心理健康应用中心" style="color:#000">中国科学院心理研究所·心理健康应用中心</a>
                <span>提供测评技术支持</span>
              </h5>
              <div class="col-xs-12 m-b-sm">
                <div style="height:20px;background:#42b983;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import H2C from "html2canvas";
import jQuery from "jquery";
import Echarts from "echarts/lib/echarts.js";
import "echarts/lib/chart/bar.js";
import "echarts/lib/component/legend";
import async from "async";

import SvgCircle from "../blocks/svg-circle.vue";
import Radar from "../blocks/radar.vue";
import Scatter from "../blocks/scatter.vue";
import Loading from "../blocks/loading.vue";

import User from "../../resource/user";
export default {
  components: {
    SvgCircle,
    Radar,
    Scatter,
    Loading
  },
  data: function() {
    return {
      loading: 1,
      report: {
        abilities: []
      },
      redar: null,
      bar: null,
      is_mounted: false,
      detail_data: 0,
      radar_data: {
        title: "",
        legend: [],
        indicator: [],
        series: []
      },
      need_refresh: -1
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser"
    })
  },
  created: function() {
    let that = this;
    document.title = `我的报告-个人中心|${that.global.name}`;
    if (that.user.category === 2) {
      that.$router.replace("/company");
    } else {
      that.load();
    }
  },
  watch: {
    "report.abilities": function(now) {
      let that = this;
      if (that.is_mounted && now.length >= 3) {
        setTimeout(function() {
          that.buildRadar();
          that.buildBar();
        }, 300);
      }
    }
  },
  mounted: function() {
    let that = this;
    that.is_mounted = true;
    if (that.report.abilities.length >= 3) {
      setTimeout(function() {
        that.buildRadar();
        that.buildBar();
      }, 300);
    }
  },
  methods: {
    load: function() {
      let that = this;
      User.report({}, {}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            let report = data.result;
            if (Object.prototype.toString.call(report) !== "[object Array]") {
              let indicators = {};
              that.need_refresh = report.ability_need_refresh;
              report.indicators.forEach(indicator => {
                indicator.score = Number(indicator.score.toFixed(2));
                indicator.rate_text = (indicator.rate * 100).toFixed(2) + "%";
                indicator.dasharray =
                  indicator.rate * 314 + " " + (1 - indicator.rate) * 314;
                if (indicator.indicator)
                  indicators[indicator.indicator._id] = indicator;
              });
              report.abilities.forEach(ability => {
                let tmpIndicators = [];
                let radar_data = {
                  title: "指标组成",
                  indicator: [],
                  series: [
                    {
                      name: "指标",
                      type: "radar",
                      itemStyle: {
                        normal: {
                          areaStyle: { type: "default" },
                          color: function(data) {
                            return "#00cc99";
                          }
                        }
                      },
                      data: [
                        {
                          value: [],
                          name: "指标"
                        }
                      ]
                    }
                  ]
                };
                ability.indicators = ability.ability.indicators;
                ability.indicators.forEach((indicator, index, arr) => {
                  var tmp = indicators[indicator.indicator];
                  if (tmp) {
                    for (let p in tmp) {
                      indicator[p] = tmp[p];
                    }
                    radar_data.indicator.push({
                      name: indicator.indicator.name,
                      max: indicator.indicator.point_system
                    });
                    radar_data.series[0].data[0].value.push(indicator.score);
                    tmpIndicators.push(tmp);
                  }
                });
                ability.indicators = tmpIndicators;
                ability.is_open = 1;
                ability.radar_data = radar_data;
              });
              that.report = report;
            }
            that.loading = 0;
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    buildRadar: function() {
      let that = this;
      let indicator = [];
      let series = [
        {
          name: "能力群得分",
          type: "radar",
          tooltip: {
            trigger: "item"
          },
          itemStyle: {
            normal: {
              areaStyle: {
                type: "default"
              },
              color: function(data) {
                return "#00cc99";
              }
            }
          },
          data: [
            {
              value: [],
              name: "能力群得分"
            }
          ]
        }
      ];
      that.report.abilities.forEach(function(ability) {
        indicator.push({
          name: ability.ability.name,
          max: ability.ability.point_system,
          tips: [
            {
              name: "建议：",
              content: ability.grade_suggestion
            }
          ]
        });
        series[0].data[0].value.push(ability.score.toFixed(2));
      });
      that.radar_data.title = "雷达图";
      // that.radar_data.legend = legend;
      that.radar_data.indicator = indicator;
      that.radar_data.series = series;
    },
    buildBar: function() {
      let that = this;
      if (!that.bar) {
        that.bar = Echarts.init(document.querySelector("#bar-area"));
      }
      let options = {
        title: {
          text: "得分详情"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          max: 100
        },
        yAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#000000",
              fontSize: 14,
              fontWeight: "Bold"
            }
          },
          data: []
        },

        series: [
          {
            name: "得分",
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "insideRight"
              }
            },
            itemStyle: {
              normal: {
                color: function(data) {
                  return "#00cc99";
                }
              }
            },
            data: []
          }
        ]
      };
      that.report.abilities.forEach(function(ability) {
        options.yAxis.data.push(ability.ability.name);
        options.series[0].data.push(ability.score.toFixed(2));
      });
      that.bar.setOption(options);
    },
    refresh: function() {
      let that = this;
      that.need_refresh = -1;
      that.$http.put("/api/v1/evaluate_results/report_refresh", {}, {}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            alert("报告已重新生成！！！");
            that.load(); //
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    download: function() {
      const that = this;
      const doc = window.document;
      async.mapLimit(
        doc.querySelectorAll(".snapshort"),
        2,
        (ra, done) => {
          H2C(ra, {
            background: "#fff",
            useCORS: true,
            onrendered: function(canvas) {
              done(null, {
                base64: canvas.toDataURL(),
                height: canvas.height,
                width: canvas.width
              });
            }
          });
        },
        (err, results) => {
          var $form = jQuery(
            '<form method="post" action="/api/base642pdf"></form>'
          );
          $form.append(
            '<textarea style="display:none;" name="base64" >' +
              JSON.stringify(results) +
              "</textarea>"
          );
          $form.append(
            `<input type="hidden" name="name" value="${that.user.realname}" />`
          );
          $form.append(`<input type="hidden" name="category" value="1" />`);
          jQuery(document.body).append($form);
          $form[0].submit();
          $form.remove();
        }
      );
    }
  },
  destroyed: function() {
    let that = this;
    if (that.echarts) {
      that.echarts.dispose();
      that.echarts = null;
    }
  }
};
</script>
<style lang="less" scoped>
.tips {
  padding: 150px 80px;
  font-size: 18px;
  line-height: 1.5;
  text-align: center;
}

#radar-area {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// report.vue?102d3a28